import { Outlet, useLocation } from 'react-router-dom';
import { useState } from 'react';
import RequireAuth from '../store/utils/RequireAuth';
import config from '../config/config';
import TermsAndConditions from '../components/TermsAndConditions';
import TermsAndServicesType from '../models/terms';
import Sidebar from '../components/Sidebar';
import useIsMobile from '../hooks/useIsMobile';
import IconBreadcrumbs from '../components/atoms/Breadcrumbs';

const AdminOutlet = () => {
  const [showTerms, setShowTerms] = useState(false);
  const location = useLocation();
  const isMobile = useIsMobile();
  return (
    <RequireAuth>
      <div className="flex flex-row w-full overflow-hidden">
        {!isMobile && <Sidebar />}
        <div className='flex flex-col w-full overflow-hidden'>
          {!/\/scanner(\/|$)/.test(location.pathname) && <div className='w-full'>{<IconBreadcrumbs />}</div>}
          <div className="flex-grow overflow-x-hidden w-full">
            <div className="min-h-screen flex flex-col">
              <div className="flex-grow w-full">
                <Outlet key={location.pathname} />
              </div>
              <div className="mt-auto pt-4 pb-2 flex flex-col justify-between items-center">
                <div className="w-full text-center text-sm text-text-secondary">
                  Al vender con Avantti, aceptas nuestros{' '}
                  <button
                    type="button"
                    className="text-primary underline"
                    onClick={() => setShowTerms(true)}
                  >
                    términos y condiciones
                  </button>
                </div>
                <div className="flex flex-col items-center">
                  <span className="text-xs">v{config.version}</span>
                </div>
              </div>
            </div>

            <TermsAndConditions
              isOpen={showTerms}
              onClose={() => setShowTerms(false)}
              type={TermsAndServicesType.SELLER}
            />
          </div></div>
      </div>
    </RequireAuth>
  );
};

export default AdminOutlet;
